export const AnalyticsActors = {
    TOGGLE_ANALYTICS:'TOGGLE_ANALYTICS',
    ANALYTICS_LIST:'ANALYTICS_LIST'
}